/**
 * Created by slava on 02.02.17.
 */

const BombByLeftMoves = function (x, y) {
    this.x = x;
    this.y = y;
    this.onExplodeListener = function () {};
    this.onAnimateListener = function () {};
};

BombByLeftMoves.prototype.go = function () {
    this.onAnimateListener();

    Game.currentGame.counter.setTimeout(() => {
        this.explode();
    }, 1400);
};

BombByLeftMoves.prototype.explode = function () {
    for (let dx = -1; dx <= 1; dx++) {
        for (let dy = -1; dy <= 1; dy++) {
            const col = this.x + dx;
            const row = this.y + dy;
            if (Game.currentGame.field.isCellInField(row, col)) {
                Game.currentGame.field.cells[row][col].hurt({
                    id: 0,
                    groupSize: 1
                });
            }
        }
    }
    this.onExplodeListener();
};

BombByLeftMoves.ChooseLocations = function (field, amount) {
    let i, j;
    const usedInExplode = [];
    for (i = 0; i < Field.SIZE; i++) {
        usedInExplode.push([]);
        for (j = 0; j < Field.SIZE; j++) {
            usedInExplode[i].push(false);
        }
    }

    const calcScoreByLeftMovesExplodeCell = function (i, j) {
        if (!field.cells[i][j] || field.cells[i][j].lives < 0) {
            return 0;
        }
        let score = 0;
        for (let di = -1; di <= 1; di++) {
            for (let dj = -1; dj <= 1; dj++) {
                const row = i + di;
                const col = j + dj;
                if (field.isCellInField(row, col)) {
                    if (field.cells[row][col].lives > 0 && !usedInExplode[row][col]) {
                        if (Game.currentGame.goals.hasType(field.cells[row][col].getGoalId())) {
                            let amountCells = 1;
                            const goalCoefComponent = field.cells[row][col].findComponent(GoalCoefComponent);
                            if (goalCoefComponent && goalCoefComponent.coef) {
                                amountCells += goalCoefComponent.coef;
                            }
                            score += 10 * amountCells;
                        } else {
                            score += 3;
                        }
                    }
                }
            }
        }
        return score;
    };

    const useCellInLeftMovesExplode = function (i, j) {
        for (let di = -1; di <= 1; di++) {
            for (let dj = -1; dj <= 1; dj++) {
                const row = i + di;
                const col = j + dj;
                if (field.isCellInField(row, col)) {
                    usedInExplode[row][col] = true;
                }
            }
        }
    };

    const res = [];
    for (let t = 0; t < amount; t++) {
        let bestPosition = false, bestScore = 0;
        for (i = 0; i < Field.SIZE; i++) {
            for (j = 0; j < Field.SIZE; j++) {
                const currentScore = calcScoreByLeftMovesExplodeCell(i, j);
                if (currentScore > bestScore) {
                    bestScore = currentScore;
                    bestPosition = { row: i, col: j };
                }
            }
        }
        if (!bestPosition) {
            break;
        }
        useCellInLeftMovesExplode(bestPosition.row, bestPosition.col);
        res.push(bestPosition);
    }

    cleverapps.shuffleInPlace(res);

    return res;
};